import { Box } from "@mui/material";

import styled from "@emotion/styled";

export const Root = styled(Box)`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    width: 100%;
`;

export const ScrollBody = styled(Box)<{ $maxWidth: number | string }>`
    flex: 1 1 auto;
    width: 100%;
    max-width: ${({ $maxWidth }) =>
        typeof $maxWidth === "number" ? `${$maxWidth}px` : $maxWidth};
    padding-right: 12px;
    padding-bottom: 8px;
`;

export const ContentInner = styled(Box)`
    width: 100%;
    padding: 8px 0 24px;
`;

export const Footer = styled(Box)`
    position: sticky;
    bottom: 0;
    flex-shrink: 0;
    width: 100%;
    border-top: 1px solid #eee;
    background-color: #fff;
    padding: 12px 0;
    padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));
    z-index: 99;
`;

export const FooterInner = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;

    @media (max-width: 480px) {
        gap: 8px;
    }
`;

export const PrimaryButtonWrap = styled(Box)`
    position: relative;
    overflow: hidden;
    margin-left: auto;

    @media (max-width: 480px) {
        flex: 1 1 auto;
        margin-left: 0;
        display: flex;
        justify-content: flex-end;

        .MuiButton-root {
            min-width: 0 !important;
            width: 100%;
            max-width: 100%;
        }
    }
`;

export const BackButton = styled(Box)`
    flex-shrink: 0;

    .MuiButton-root {
        max-width: 80px !important;
        min-width: 80px !important;
    }
`;
